import { useMutation } from '../';
import { newNotificationRecipient } from '../mutations';

export function useNewNotificationRecipient() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    return mutate(newNotificationRecipient, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.newNotificationRecipient.id);
      }
    });
  };

  return { data, isLoading, run };
}
